import type { SVGProps } from "react";

interface SVGRProps {
	title?: string;
	titleId?: string;
	size?: number | string;
}
export const AddToCartIcon = ({
	title,
	titleId,
	size = 32,
	...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size}
		height={size}
		viewBox="0 0 32 32"
		fill="none"
		aria-labelledby={titleId}
		{...props}
	>
		{title ? <title id={titleId}>{title}</title> : null}
		<path
			stroke="#0E0E0E"
			strokeLinecap="round"
			strokeLinejoin="bevel"
			strokeWidth={1.5}
			d="M21.939 12v0c-.046-.565-.518-1-1.085-1H9.986a2 2 0 0 0-1.993 1.837l-.816 10A2 2 0 0 0 9.17 25h12.594a1.14 1.14 0 0 0 1.135-1.232v0M18 9a3 3 0 1 0-6 0"
		/>
		<path
			stroke="#0E0E0E"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M22.5 15v5m2.5-2.5h-5"
		/>
	</svg>
);
